import type { Dashboard } from './dashboard.type.ts';
import type { LayoutConfig, LayoutSection } from './dashboard.type';

export type { LayoutConfig, LayoutSection };
export interface DashboardExtension extends Dashboard {}
export class DashboardExtension {
  get isGlobal() {
    return this.visibilityLevel === 'global';
  }

  get isPartnerShared() {
    return this.visibilityLevel === 'partner';
  }

  get isPrivate() {
    return this.visibilityLevel === 'private';
  }

  get reportCount() {
    return this.dashboardReports?.length ?? 0;
  }

  get orderedReports() {
    return [...(this.dashboardReports ?? [])].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
  }

  get visibilityLabel() {
    switch (this.visibilityLevel) {
      case 'private':
        return 'Private';
      case 'partner':
        return 'Custom Partner Dashboard';
      case 'global':
        return 'Global';
      default:
        return 'Unknown';
    }
  }
}

const Registration = {
  kind: 'object',
  name: 'dashboard',
  features: DashboardExtension,
};
export default Registration;
